import React from 'react'
import {ProjectTeaser} from 'betterplace-react-components'
import {GtmHelper, ga} from 'shared'
import VisibilitySensor from 'react-visibility-sensor/visibility-sensor'

export class ProjectTeaserWithTracking extends React.Component {
  handleClick = () => {
    const { project, trackingPath, sourceProjectID, index } = this.props

    ga('send', 'event', trackingPath, 'target-page', project.id)
    if (sourceProjectID) {
      ga('send', 'event', trackingPath, 'source-page', sourceProjectID)
    }
    GtmHelper.pushProjectClicks(project, index + 1, trackingPath)
  }

  handleVisibilityChange = (isVisible) => {
    if (!isVisible || this.tracked) return
    GtmHelper.pushProjectImpressions(this.props.project, this.props.index + 1, this.props.trackingPath)
    this.tracked = true
  }

  render() {
    return <VisibilitySensor scrollCheck onChange={this.handleVisibilityChange}>
      <ProjectTeaser
        project={this.props.project}
        className={this.props.className}
        showDescription={!!this.props.showDescription}
        progressbarColor={this.props.progressbarColor || '#9ECB0A'}
        textColor='#000000'
        onClick={ this.handleClick }
        openInTab={this.props.openInTab} />
    </VisibilitySensor>
  }
}
